import React from 'react'
import { withAsync } from '@/components/Async'
import Blank from '@/layouts/Blank'
import type { RouteConfig } from 'react-router-config'
import { OwStorage } from '@yy/one-icon'
import { withRedirect } from '@/components/Authorization'

const routes: RouteConfig[] = [
  {
    name: 'warehousing',
    menuTitle: 'common.router.warehousing',
    path: '/warehousing',
    component: withRedirect(Blank),
    icon: <OwStorage />,
    authCode: 'inbounds',
    routes: [
      // 采购入库
      {
        path: '/list/purchase',
        component: withAsync(() => import('@/containers/Warehousing')),
        menuTitle: 'warehousing.detail.purchase',
        authCode: 'inbounds:management',
      },
      // 退货入库
      {
        path: '/list/return',
        component: withAsync(() => import('@/containers/Warehousing')),
        menuTitle: 'enums.inboundType.return',
        authCode: 'inbounds:return',
      },
      {
        path: '/create',
        component: withAsync(() => import('@/containers/Warehousing/Create')),
        // 用于关联parentKeys，没有menuTitle会被过滤
        menuTitle: '创建入库单',
        hideInMenu: true,
        parentKeys: ['/warehousing/list/purchase'],
      },
      {
        path: '/edit',
        component: withAsync(() => import('@/containers/Warehousing/Create')),
        // 用于关联parentKeys，没有menuTitle会被过滤
        menuTitle: '编辑入库单',
        hideInMenu: true,
        parentKeys: ['/warehousing/list/purchase'],
      },
      {
        path: '/detail',
        component: withAsync(() => import('@/containers/Warehousing/Detail')),
        // 用于关联parentKeys，没有menuTitle会被过滤
        menuTitle: '入库单详情',
        hideInMenu: true,
        parentKeys: ['/warehousing/list'],
      },
    ],
  },
]

export default routes
